module.exports = __webpack_public_path__ + "img/security.1123d7ea.svg";